// extracted by mini-css-extract-plugin
export default {"main":"b8ec9c6790 c092e70ee8","xmark":"_73133df0a8","fl_img":"_42226b8567 _37707848f1"};